import axios from "axios";
// set LeadsTableData
export const SetLeadsStorage = (item, value) => {
  localStorage.setItem(item, JSON.stringify(value));
};
// get LeadsTableData
export const GetLeadsProfile = (items) => {
  return JSON.parse(localStorage.getItem(items) || null);
};
// set LeadsTableData
export const SetProspectStorage = (item, value) => {
  localStorage.setItem(item, JSON.stringify(value));
};
// get LeadsTableData
export const GetProspectStorage = (item) => {
  return JSON.parse(localStorage.getItem(item) || null);
};
// set person id
export const SetPersonId = (item, value) => {
  localStorage.setItem(item, JSON.stringify(value));
};
// get person id
export const GetPersonId = (item) => {
  return JSON.parse(localStorage.getItem(item) || null);
};

// set person id
export const SetOrgId = (item, value) => {
  localStorage.setItem(item, JSON.stringify(value));
};
// get person id
export const GetOrgId = (item) => {
  return JSON.parse(localStorage.getItem(item) || null);
};

export const SetOktaAuthData = (item, value) => {
  localStorage.setItem(item, JSON.stringify(value));
};
export const GetOktaAuthData = () => {
  return JSON.parse(localStorage.getItem("auth") || null);
};
export const setStatsData = (item, value) => {
  localStorage.setItem(item, JSON.stringify(value));
};
export const GetStatsData = () => {
  return JSON.parse(localStorage.getItem("statsData") || null);
};

export const setLeadsFilterStatsData = (item, value) => {
  localStorage.setItem(item, JSON.stringify(value));
};
export const GetLeadsFilterStatsData = () => {
  return JSON.parse(localStorage.getItem("filterstatscount") || null);
};
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const isValidEmail = (email) => {
  return emailRegex.test(email);
};
// for api urls
// http://172.214.83.217:8000
export const APISalesforceUrl = () => {
  return process.env.REACT_APP_SALESFORCE_API_URL;
};
export const APIGraphUrl = () => {
  return process.env.REACT_APP_GRAPH_API_URL;
};
export const APIDataUrl = () => {
  return process.env.REACT_APP_DATA_API_URL;
};
// for login user
export const SetUserId = (item, value) => {
  localStorage.setItem(item, JSON.stringify(value));
};
export const GetUserId = () => {
  return localStorage.getItem("userId") || null;
};
// export const ClientId = () => {
//     return "0oaez4a6k38GCrsto5d7"
// }
// export const RedirectUrl = () => {
//     return "http://localhost:3000/login/callback"
// }

export const APITokenUrl = () => {
  return process.env.REACT_APP_TOKEN_API_URL;
};

export const getConfidenceScore = (number) => {
  if (number * 10 >= 76.68 && number * 10 < 100) {
    return "A";
  } else if (number * 10 >= 60 && number * 10 < 76.67) {
    return "B";
  } else if (number * 10 >= 40 && number * 10 < 60) {
    return "C";
  } else if (number * 10 >= 0 && number * 10 < 40) {
    return "D";
  } else {
    return "Invalid Input";
  }
};


export const APIChatUrl = () => {
  return process.env.REACT_APP_CHAT_API_URL;
};
export const APIWebSocketUrl = () => {
  return process.env.REACT_APP_WEB_SOCKET_URL;
};
export const APIWebSocketToken = () => {
  return process.env.REACT_APP_WEB_SOCKET_TOKEN;
};
